"use strict";

function ResourceConfig() {
  function getResources() {
    const AllPropertiesGeoServerLayer = require("../esg/geoServer/allPropertiesGeoServerLayer");
    const PropertiesFilters = require("../esg/geoServer/propertiesFilters");
    const PlanPropertiesGeoServerLayer = require("../esg/geoServer/planPropertiesGeoServerLayer");
    const ApiCalls = require("../apiCalls");
    const BmpFilter = require("../filters/bmpFilter");
    const ConstructionFilters = require("../construction/constructionFilters");
    const ConstructionProjectGeoServerLayer = require("../constructionG2/constructionProjectGeoServerLayer");
    const ConstructionProjectG2Filters = require("../constructionG2/constructionProjectG2Filters");
    const ConstructionProjectLayer = require("../construction/constructionProjectLayer");
    const DataResource = require("../offline/dataResource");
    const FacilityInspectionConstants = require("../indcom/facilityInspection/facilityInspectionConstants");
    const FacilityInspectionController = require("../indcom/facilityInspection/facilityInspectionController");
    const IndcomFacilityFilters = require("../indcom/indcomFacilityFilters");
    const IndcomFacilityGeoServerLayer = require("../indcom/indcomFacilityGeoServerLayer");
    const MainMap = require("../mapFunctions/mainMap");
    const MuniCatchBasinFilters = require("../muni/muniCatchBasinFilters");
    const MuniCatchBasinGeoServerLayer = require("../muni/muniCatchBasinGeoServerLayer");
    const MuniCleanoutFilters = require("../muni/muniCleanoutFilters");
    const MuniCleanoutGeoServerLayer = require("../muni/muniCleanoutGeoServerLayer");
    const MuniBmpFilters = require("../muni/bmp/muniBmpFilters");
    const MuniBmpGeoServerLayer = require("../muni/bmp/muniBmpGeoServerLayer");
    const LidBmpGeoServerLayer = require("../lid/lidBmpGeoServerLayer");
    const LidBmpFilters = require("../lid/lidBmpFilters");
    const MuniCulvertFilters = require("../muni/culvert/muniCulvertFilters");
    const MuniCulvertGeoServerLayer = require("../muni/culvert/muniCulvertGeoServerLayer");
    const MuniOpenChannelFilters = require("../muni/openChannel/muniOpenChannelFilters");
    const MuniOpenChannelGeoServerLayer = require("../muni/openChannel/muniOpenChannelGeoServerLayer");
    const MuniManholeFilters = require("../muni/muniManholeFilters");
    const MuniManholeGeoServerLayer = require("../muni/muniManholeGeoServerLayer");
    const MuniLiftStationsGeoServerLayer = require("../muni/muniLiftStationsGeoServerLayer");
    const MuniOutfallsFilters = require("../muni/outfalls/muniOutfallsFilters");
    const MuniLiftStationsFilters = require("../muni/muniLiftStationsFilters");
    const MuniOutfallsGeoServerLayer = require("../muni/outfalls/muniOutfallsGeoServerLayer");
    const OutfallFunctions = require("../outfalls/outfallFunctions");
    const ProjectDeliveryFilters = require("../projectDelivery/projectDeliveryFilters");
    const ProjectInspectionConstants = require("../construction/inspections/projectInspectionConstants");
    const ProjectInspectionController = require("../construction/inspections/projectInspectionController");
    const NewProjectInspectionController = require("../construction/newInspections/newProjectInspectionController");
    const NewProjectInspectionConstants = require("../construction/newInspections/newProjectInspectionConstants");
    const AssetRoutineMaintenanceController = require("../inspection/routineMaintenance/assetRoutineMaintenanceController");
    const AssetRoutineMaintenanceData = require("../inspection/routineMaintenance/assetRoutineMaintenanceData");
    const DataNotFoundError = require("../errors/dataNotFoundError");
    const HardAssetInspectionGate = require("../muni/hardAssetInspectionGate");
    const MuniPipesFilters = require("../muni/muniPipesFilters");
    const MuniPipesGeoServerLayer = require("../muni/muniPipesGeoServerLayer");
    const projectDeliveryBmpsGeoServerLayer = require("../projectDelivery/projectDeliveryBmpsGeoServerLayer");
    const SimpleOutfallGeoServerDynamicMapLayer = require("../outfalls/simpleOutfallGeoServerDynamicMapLayer");
    const StructuralBmpsGeoServerLayer = require("../bmpFcsG2/structuralBmpsGeoServerLayer");
    const StructuralBmpFilters = require("../bmpFcsG2/structuralBmpFilters");
    const TelrResultBmpGeoServerLayer = require("../scenario/telrResultBmpGeoServerLayer");
    const TelrResultBmpFilters = require("../scenario/telrResultBmpFilters");
    const PostConstructionProjectGeoServerLayer = require("../constructionG2/postConstructionProjectGeoServerLayer");
    const PostConstructionProjectG2Filters = require("../constructionG2/postConstructionProjectG2Filters");
    const IncentiveProgramsGeoServerLayer = require("../esg/geoServer/incentiveProgramsGeoServerLayer");
    const IncentiveProgramsFilters = require("../esg/geoServer/incentiveProgramsFilters");
    const ScenarioFilter = require("../filters/scenarioFilter");
    const MonitoringLocationFilters = require("../illicitDischarge/monitoringLocationFilters");
    const MonitoringLocationGeoServerLayer = require("../illicitDischarge/monitoringLocationGeoServerLayer");
    const incidentsFilters = require("../illicitDischarge/incidents/incidentsFilters");
    const IncidentsGeoServerLayer = require("../illicitDischarge/incidents/incidentsGeoServerLayer");
    const ActivitiesLayer = require("../peo/activitiesLayer");
    const ActivityFilters = require("../peo/activityFilters");
    const SamplingSiteGeoServerLayer = require("../wq/samplingSiteGeoServerLayer");
    const SamplingSiteFilters = require("../wq/samplingSiteFilters");
    const WqMonitoringLocationGeoServerLayer = require("../wq/wqMonitoringLocationGeoServerLayer");
    const WqMonitoringGeoServerLayerFilters = require("../wq/wqMonitoringGeoServerLayerFilters");
    const InspectableAssetCache = require("../offline/inspectableAssetCache");

    const assetInspectionOptions = function (assetType, mapOfflineData = null) {
      const saveStandard = async function (initial, changes, syncId, isNew) {
        const uploadData = AssetRoutineMaintenanceController.getUpdateData(initial, changes, isNew);
        uploadData.syncId = syncId;

        return await ApiCalls.createOrUpdateAssetRoutineMaintenance(uploadData);
      };

      return {
        getRelatedData: (data) => data.assetInfo,
        getNewOnline: async (id, { forcedInspectionType = null } = {}) =>
          AssetRoutineMaintenanceData.getNewInspectionDefaults(
            await ApiCalls.getMaintenanceInspectableAsset(id, assetType),
            forcedInspectionType,
          ),
        processNewOfflineData: async (data, { forcedInspectionType = null } = {}) =>
          AssetRoutineMaintenanceData.getNewInspectionDefaultsFromAsset(
            assetType,
            mapOfflineData ? mapOfflineData(data) : data,
            forcedInspectionType,
          ),
        getExistingOnline: (id) => ApiCalls.getAssetRoutineMaintenance(id, assetType),
        processExistingOnlineData: (allData) =>
          AssetRoutineMaintenanceData.organizeExistingData(allData),
        saveNewOnline: (initial, changes, syncId) => saveStandard(initial, changes, syncId, true),
        saveUpdatesOnline: (initial, changes, syncId) =>
          saveStandard(initial, changes, syncId, false),
      };
    };

    // Offline inspections start from the asset type's cache of server-built assetInfo, so they
    // match what the online form gets. Types without a cache can't start inspections offline.
    // Resources are created before feature flags load, so the gate is checked on use instead.
    // Saves cover offline inspections syncing too, and every inspection type the form supports,
    // including IDDE dry weather screenings.
    const hardAssetInspectionOptions = function (assetType, inspectableResourceKey) {
      const standardOptions = assetInspectionOptions(assetType);
      const saveAndRefreshCache = async function (save, initial, changes, syncId) {
        const result = await save(initial, changes, syncId);
        InspectableAssetCache.refreshAsset(assetType, initial.assetInfo.id);
        return result;
      };

      return {
        ...standardOptions,
        saveNewOnline: (initial, changes, syncId) =>
          saveAndRefreshCache(standardOptions.saveNewOnline, initial, changes, syncId),
        saveUpdatesOnline: (initial, changes, syncId) =>
          saveAndRefreshCache(standardOptions.saveUpdatesOnline, initial, changes, syncId),
        relatedResourceKey: inspectableResourceKey,
        processNewOfflineData: async ({ id, assetInfo }, { forcedInspectionType = null } = {}) => {
          if (!HardAssetInspectionGate.isOfflineEnabledForAssetType(assetType)) {
            throw new DataNotFoundError(`Offline ${assetType} inspections are disabled.`, id);
          }

          return AssetRoutineMaintenanceData.getNewInspectionDefaults(
            { assetInfo },
            forcedInspectionType,
          );
        },
      };
    };

    // sBMPs could already start offline inspections from their map layer rows before they had a
    // cache, so they keep doing that while the muni-hard-asset-inspections flag is off.
    const sbmpInspectionOptions = function () {
      const cacheOptions = hardAssetInspectionOptions("bmpFcs", "sbmpInspectable");
      const layerRowOptions = {
        ...assetInspectionOptions("bmpFcs", (data) => ({
          ...data,
          bmpType: data.type,
          activeMaintenanceIssues: data.routineRepairBmp?.additionalInfo ?? [],
        })),
        relatedResourceKey: "muniBmp",
      };
      const getOfflineOptions = () =>
        HardAssetInspectionGate.isOfflineEnabledForAssetType("bmpFcs")
          ? cacheOptions
          : layerRowOptions;

      return {
        ...cacheOptions,
        relatedResourceKey: () => getOfflineOptions().relatedResourceKey,
        processNewOfflineData: (data, options) =>
          getOfflineOptions().processNewOfflineData(data, options),
      };
    };

    return [
      // Warning: renaming keys will invalidate offline data.

      // See DataResource for available `options`
      {
        resource: DataResource,
        key: "fcs",
        options: {
          getAllOnline: ApiCalls.getFcss,
          filterResourceDataHandler: BmpFilter.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "scenarios",
        options: {
          getAllOnline: ApiCalls.getUnfilteredScenarios,
          filterResourceDataHandler: ScenarioFilter.filterResourceDataHandler,
        },
      },
      // Construction
      {
        resource: DataResource,
        key: "constructionProject",
        options: {
          getAllOnline: ConstructionProjectLayer.getProjectDeliveryLayerData,
          filterResourceDataHandler: ConstructionFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "constructionProjectG2",
        options: {
          getAllOnline: (loadingScreen) =>
            ConstructionProjectGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: ConstructionProjectG2Filters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "postConstructionProjectG2",
        options: {
          getAllOnline: (loadingScreen) =>
            PostConstructionProjectGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: PostConstructionProjectG2Filters.filterResourceDataHandler,
        },
      },

      {
        resource: DataResource,
        key: "incidents",
        options: {
          getAllOnline: (loadingScreen) =>
            IncidentsGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: incidentsFilters.filterResourceDataHandler,
        },
      },

      {
        resource: DataResource,
        key: "constructionProjectInspection",
        options: {
          formLockedKey: "locked",
          getRelatedData: (data) => data.project,
          relatedResourceKey: "constructionProjectG2",
          getNewOnline: async function (id) {
            var data = await ApiCalls.getNewConstructionProjectInspection(id);
            data = ProjectInspectionConstants.getNewProjectInspectionDefaults(data);
            return ProjectInspectionConstants.organizeProjectInspectionData(data);
          },
          processNewOfflineData: async function (data) {
            return ProjectInspectionConstants.getNewProjectInspectionDefaults(data);
          },
          getExistingOnline: ApiCalls.getExistingConstructionProjectInspection,
          processExistingOnlineData: ProjectInspectionConstants.organizeProjectInspectionData,
          saveNewOnline: async function (initial, changes, syncId) {
            const data = ProjectInspectionController.getUpdateData(initial, changes, true);
            data.syncId = syncId;

            return await ApiCalls.createConstructionProjectInspection(data);
          },
          saveUpdatesOnline: async function (initial, changes, syncId) {
            const data = ProjectInspectionController.getUpdateData(initial, changes, false);
            data.syncId = syncId;

            return await ApiCalls.updateConstructionProjectInspection(data);
          },
        },
      },

      {
        resource: DataResource,
        key: "newConstructionProjectInspection",
        options: {
          formLockedKey: "locked",
          getRelatedData: (data) => data.project,
          relatedResourceKey: "constructionProjectG2",
          getNewOnline: async function (id) {
            var data = await ApiCalls.getNewConstructionProjectInspection(id);
            data = NewProjectInspectionConstants.getNewProjectInspectionDefaults(data);
            return NewProjectInspectionConstants.prepareInspectionData(data);
          },
          processNewOfflineData: async function (data) {
            data = {
              project: data,
              openFindings: data.openFindings,
              inspectionObservations: [],
            };
            data = NewProjectInspectionConstants.getNewProjectInspectionDefaults(data);

            return NewProjectInspectionConstants.prepareInspectionData(data);
          },
          getExistingOnline: ApiCalls.getExistingConstructionProjectInspection,
          processExistingOnlineData: NewProjectInspectionConstants.prepareInspectionData,
          saveNewOnline: async function (initial, changes, syncId) {
            const data = NewProjectInspectionController.getUpdateData(initial, changes, true);
            data.syncId = syncId;

            return await ApiCalls.createConstructionProjectInspection(data);
          },
          saveUpdatesOnline: async function (initial, changes, syncId) {
            const data = NewProjectInspectionController.getUpdateData(initial, changes, false);
            data.syncId = syncId;

            return await ApiCalls.updateConstructionProjectInspection(data);
          },
          postSync: NewProjectInspectionController.postUpdate,
        },
      },

      // Muni catch basin
      {
        resource: DataResource,
        key: "muniCatchBasin",
        options: {
          getAllOnline: (loadingScreen) =>
            MuniCatchBasinGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: MuniCatchBasinFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "structuralBmps",
        options: {
          getAllOnline: (loadingScreen) =>
            StructuralBmpsGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: StructuralBmpFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "planProperties",
        options: {
          getAllOnline: (loadingScreen) =>
            PlanPropertiesGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: PropertiesFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "allProperties",
        options: {
          getAllOnline: (loadingScreen) =>
            AllPropertiesGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: PropertiesFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "muniManhole",
        options: {
          getAllOnline: (loadingScreen) =>
            MuniManholeGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: MuniManholeFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "manholeInspectable",
        options: {
          getAllOnline: () => InspectableAssetCache.fetchAll("manholeInspectable"),
        },
      },
      {
        resource: DataResource,
        key: "monitoringLocation",
        options: {
          getAllOnline: (loadingScreen) =>
            MonitoringLocationGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: MonitoringLocationFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "samplingSites",
        options: {
          getAllOnline: (loadingScreen) =>
            SamplingSiteGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: SamplingSiteFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "wqMonitoringLocations",
        options: {
          getAllOnline: (loadingScreen) =>
            WqMonitoringLocationGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: WqMonitoringGeoServerLayerFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "muniCleanout",
        options: {
          getAllOnline: (loadingScreen) =>
            MuniCleanoutGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: MuniCleanoutFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "cleanoutInspectable",
        options: {
          getAllOnline: () => InspectableAssetCache.fetchAll("cleanoutInspectable"),
        },
      },
      {
        resource: DataResource,
        key: "muniLiftStations",
        options: {
          getAllOnline: (loadingScreen) =>
            MuniLiftStationsGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: MuniLiftStationsFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "liftStationInspectable",
        options: {
          getAllOnline: () => InspectableAssetCache.fetchAll("liftStationInspectable"),
        },
      },
      {
        resource: DataResource,
        key: "muniBmp",
        options: {
          getAllOnline: (loadingScreen) => MuniBmpGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: MuniBmpFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "sbmpInspectable",
        options: {
          getAllOnline: () => InspectableAssetCache.fetchAll("sbmpInspectable"),
        },
      },
      {
        resource: DataResource,
        key: "lidBmp",
        options: {
          getAllOnline: (loadingScreen) => LidBmpGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: LidBmpFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "muniCulvert",
        options: {
          getAllOnline: (loadingScreen) =>
            MuniCulvertGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: MuniCulvertFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "culvertInspectable",
        options: {
          getAllOnline: () => InspectableAssetCache.fetchAll("culvertInspectable"),
        },
      },
      {
        resource: DataResource,
        key: "projectDeliveryBmps",
        options: {
          getAllOnline: (loadingScreen) =>
            projectDeliveryBmpsGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: ProjectDeliveryFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "telrResultBmp",
        options: {
          getAllOnline: (loadingScreen) =>
            TelrResultBmpGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: TelrResultBmpFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "muniOpenChannel",
        options: {
          getAllOnline: (loadingScreen) =>
            MuniOpenChannelGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: MuniOpenChannelFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "openChannelInspectable",
        options: {
          getAllOnline: () => InspectableAssetCache.fetchAll("openChannelInspectable"),
        },
      },
      {
        resource: DataResource,
        key: "muniPipes",
        options: {
          getAllOnline: (loadingScreen) =>
            MuniPipesGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: MuniPipesFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "pipeInspectable",
        options: {
          getAllOnline: () => InspectableAssetCache.fetchAll("pipeInspectable"),
        },
      },
      {
        resource: DataResource,
        key: "simpleOutfallGeoServerDynamicMap",
        options: {
          getAllOnline: (loadingScreen) =>
            SimpleOutfallGeoServerDynamicMapLayer.getLayerData(false, loadingScreen),
        },
      },
      {
        resource: DataResource,
        key: "routineMaintenanceInspection",
        options: {
          ...assetInspectionOptions("bmpFcs"),
          relatedResourceKey: "muniCatchBasin",
          postSync: MainMap.reloadBmpFcsLayerWithoutLoadingScreen,
        },
      },

      // Muni outfalls
      {
        resource: DataResource,
        key: "muniOutfalls",
        options: {
          getAllOnline: (loadingScreen) =>
            MuniOutfallsGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: MuniOutfallsFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "outfallRoutineMaintenance",
        options: {
          ...assetInspectionOptions("outfall"),
          relatedResourceKey: "muniOutfalls",
          postSync: OutfallFunctions.invalidateCurrentOutfallLayerWithoutLoadingScreen,
        },
      },

      {
        resource: DataResource,
        key: "manholeRoutineMaintenance",
        options: {
          ...hardAssetInspectionOptions("manhole", "manholeInspectable"),
          postSync: MuniManholeGeoServerLayer.invalidateLayerData,
        },
      },

      {
        resource: DataResource,
        key: "pipeRoutineMaintenance",
        options: {
          ...hardAssetInspectionOptions("pipe", "pipeInspectable"),
          postSync: MuniPipesGeoServerLayer.invalidateLayerData,
        },
      },

      {
        resource: DataResource,
        key: "culvertRoutineMaintenance",
        options: {
          ...hardAssetInspectionOptions("culvert", "culvertInspectable"),
          postSync: MuniCulvertGeoServerLayer.invalidateLayerData,
        },
      },

      {
        resource: DataResource,
        key: "openChannelRoutineMaintenance",
        options: {
          ...hardAssetInspectionOptions("openChannel", "openChannelInspectable"),
          postSync: MuniOpenChannelGeoServerLayer.invalidateLayerData,
        },
      },

      {
        resource: DataResource,
        key: "liftStationRoutineMaintenance",
        options: {
          ...hardAssetInspectionOptions("liftStation", "liftStationInspectable"),
          postSync: MuniLiftStationsGeoServerLayer.invalidateLayerData,
        },
      },

      {
        resource: DataResource,
        key: "cleanoutRoutineMaintenance",
        options: {
          ...hardAssetInspectionOptions("cleanout", "cleanoutInspectable"),
          postSync: MuniCleanoutGeoServerLayer.invalidateLayerData,
        },
      },

      {
        resource: DataResource,
        key: "samplingSiteInspection",
        options: {
          ...assetInspectionOptions("sampling-site"),
          relatedResourceKey: "samplingSites",
          postSync: SamplingSiteGeoServerLayer.invalidateLayerData,
        },
      },

      // BMP
      {
        resource: DataResource,
        key: "bmpRoutineMaintenanceInspection",
        options: {
          ...sbmpInspectionOptions(),
          postSync: MainMap.reloadBmpFcsLayerWithoutLoadingScreen,
        },
      },

      // Indcom
      {
        resource: DataResource,
        key: "indcomFacilities",
        options: {
          getAllOnline: (loadingScreen) =>
            IndcomFacilityGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: IndcomFacilityFilters.filterResourceDataHandler,
        },
      },
      {
        resource: DataResource,
        key: "facilityInspection",
        options: {
          formLockedKey: "locked",
          getRelatedData: (data) => data.facility,
          relatedResourceKey: "indcomFacilities",
          getNewOnline: async function (id) {
            var data = await ApiCalls.getNewFacilityInspection(id);
            data = FacilityInspectionConstants.getNewFacilityInspectionDefaults(data);
            return FacilityInspectionConstants.prepareInspectionData(data);
          },
          processNewOfflineData: async function (data) {
            data = {
              facility: data,
              openFindings: data.openFindings,
            };
            data = FacilityInspectionConstants.getNewFacilityInspectionDefaults(data);

            return FacilityInspectionConstants.prepareInspectionData(data);
          },
          getExistingOnline: ApiCalls.getExistingFacilityInspection,
          processExistingOnlineData: FacilityInspectionConstants.prepareInspectionData,
          saveNewOnline: async function (initial, changes, syncId) {
            const data = FacilityInspectionController.getUpdateData(initial, changes, true);
            data.syncId = syncId;

            return await ApiCalls.createFacilityInspection(data);
          },
          saveUpdatesOnline: async function (initial, changes, syncId) {
            const data = FacilityInspectionController.getUpdateData(initial, changes, false);
            data.syncId = syncId;

            return await ApiCalls.updateFacilityInspection(data);
          },
          postSync: IndcomFacilityGeoServerLayer.invalidateLayerData,
        },
      },
      {
        resource: DataResource,
        key: "activities",
        options: {
          getAllOnline: (loadingScreen) => ActivitiesLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: ActivityFilters.filterResourceDataHandler,
        },
      },
      // ESG
      {
        resource: DataResource,
        key: "incentivePrograms",
        options: {
          getAllOnline: (loadingScreen) =>
            IncentiveProgramsGeoServerLayer.getLayerData(false, loadingScreen),
          filterResourceDataHandler: IncentiveProgramsFilters.filterResourceDataHandler,
        },
      },
    ];
  }

  return { getResources };
}

module.exports = ResourceConfig();
